module.exports = __webpack_public_path__ + "img/ios-share.0f7b6e25.png";